import React from 'react'

import Grid from '@material-ui/core/Grid'
import Toolbar, { ToolbarProps } from '@material-ui/core/Toolbar'

import AppLogo from 'components/AppLogo'
import LinkIconButton from 'components/LinkIconButton'
import AccountInfo from 'components/AccountInfo'

type AccountInfoProps = React.ComponentProps<typeof AccountInfo>

interface Props extends ToolbarProps {
  accountInfo?: AccountInfoProps
}

const ToolbarMobile: React.SFC<Props> = ({
  accountInfo,
  ...props
}) => (
  <Toolbar color="accent" {...props}>
    <Grid alignItems="center" justify="space-between" direction="row" container>
      <Grid xs item />
      <Grid xs item>
        <Grid justify="center" container>
          <Grid item>
            <LinkIconButton to="/games">
              <AppLogo color="primary" />
            </LinkIconButton>
          </Grid>
        </Grid>
      </Grid>
      <Grid xs item>
        <Grid justify="flex-end" container>
          <Grid item>
            <AccountInfo {...accountInfo} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Toolbar>
)

export default ToolbarMobile
